import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'

import { store } from 'root-redux/store'

import { initSentry } from 'helpers/initSentry'

import { App } from './App'
import './i18n'
import './styles/rootStyles.css'

declare global {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  interface Window {
    // Facebook Pixel
    fbq: any
    // TikTok Pixel
    ttq: any
    // Snap Pixel
    snaptr: any
    // Reddit Pixel
    rdt: any
    // Outbrain Pixel
    obApi: any
    // Taboola Pixel
    _tfa: any
    // Axon Pixel
    axon: any
    // AppsFlyer WebSDK
    AF: any
    // Google analytics
    gtag: any
    MSStream: any
    LiveChatWidget: any
    goaffproTrackConversion: any
    goaffpro_order: any
    pintrk: any
  }
}

initSentry()
const root = createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
)
export { OptionType } from 'root-constants'
